const series = [
    {
        name: 'Issues related to the business model',
        value: 'Item 1'
    },
    {
        name: 'The requested amount was too high',
        value: 'Item 2'
    },
    {
        name: 'The skills of the team were not strong enough',
        value: 'Item 3'
    },
    {
        name: 'I don\'t know',
        value: 'Item 4'
    },
    {
        name: 'Other',
        value: 'other'
    },
];

/**
 * 
 * @param props 
 */
export const mainFailureFactorsChartCalculation = (submissions: any, transformData: any, type: string = 'bar') => {
    const calculateData = (value: string) => {
        return transformData.map(({name, keyQuestion}: any) => {
            const filteredSubmission = submissions.filter((submission: any) => submission[keyQuestion] === value);

            return {
                name,
                y:  filteredSubmission.length / submissions.length * 100,
            }
        });
    }         

    return {
        chart: {
            type,
        },
        xAxis: {
            categories: transformData.map(({ name }: any) => name),
        },
        yAxis: {
            min: 0,
            max: 100,
            labels: {
              format: '{value}%'
            },
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: false,
                },
                groupPadding: 0.1,
            },
        },
        title: {
            text: 'KPI: Main failure factors',
            align: 'left',
        },
        series: series.map(series => ({
            showInLegend: true,
            name: series.name,
            type: 'column',
            data: calculateData(series.value),
        })),
    } as Highcharts.Options;
}